import { EventType } from "@/components/LetalkWizardSurveyPage/protocols/LetalkWizardDialogProtocol"
import useStyles from "@/components/LetalkWizardSurveyPage/styles"
import React, { useEffect } from "react"

type LetalkWizardSurveyPageProps = {
	openSurvey?: boolean;
	letalkWizardUrl: string;
	initVariables?: Record<string, unknown>;
	onFormAnswered?: (event: EventType) => void;
	onLetalkWizardInit?: () => void;
	onError?: () => void;
};

const LetalkWizardSurveyPage: React.FC<LetalkWizardSurveyPageProps> = (props) => {
	const {
		openSurvey,
		letalkWizardUrl,
		initVariables = {},
		onFormAnswered,
		onLetalkWizardInit,
		onError
	} = props

	const classes = useStyles()

	const getUrlFormattedInitParams = () => {
		const urlParams = new URLSearchParams()

		for (const key in initVariables) {
			const value = initVariables[key]
			urlParams.append(key, String(value ?? ""))
		}

		return urlParams.toString()
	}

	const urlParams = getUrlFormattedInitParams()

	useEffect(() => {
		try {
			const handleMessage = (event: EventType) => {
				const eventId = String(event.data?.event_id)

				if (eventId === "form_answered") {
					onFormAnswered?.(event)
				}

				if (eventId === "clear_url_params" && openSurvey) {
					window.history.replaceState({}, "", window.location.pathname)
				}
			}

			window.addEventListener("message", handleMessage)

			onLetalkWizardInit?.()

			return () => {
				window.removeEventListener("message", handleMessage)
			}
		} catch (error) {
			onError?.()
		}
	}, [openSurvey, onFormAnswered, onLetalkWizardInit, onError])

	if (!openSurvey) return null

	return (
		<div className={classes.letalkWizardContainer}>
			<iframe
				src={`${letalkWizardUrl}?${urlParams}`}
				style={{
					width: "100%",
					height: "100vh",
					border: "none"
				}}
			/>
		</div>
	)
}

export default LetalkWizardSurveyPage
